const classBaseInf = [
  {
    value: 'class_code',
    name: '班级代码',
    option: {
      width: '76px'
    }
  },
  {
    value: 'name',
    name: '班级名称'
  },
  {
    value: 'org',
    name: '部门'
  },
  {
    value: 'specialized',
    name: '项目'
  },
  {
    value: 'fee',
    name: '级别',
    isHide: true
  },
  {
    value: 'scud',
    name: '课程表',
    option: {
      width: '44px',
      align: 'center'
    }
  },
  {
    value: 'is_rocking_number',
    name: '摇号',
    option: {
      width: '40px',
      align: 'center'
    }
  },
  {
    value: 'is_publish',
    name: '对外发布',
    option: {
      width: '40px',
      align: 'center'
    }
  },
  {
    value: 'is_interview',
    name: '面试',
    option: {
      width: '40px',
      align: 'center'
    }
  },
  {
    value: 'teacher',
    name: '教师',
    option: {
      align: 'center'
    }
  },
  {
    value: 'courses_count',
    name: '课次',
    option: {
      width: '30px',
      align: 'center'
    }
  },
  {
    value: 'class_fee',
    name: '学费',
    option: {
      align: 'center',
      width: '40px'
    }
  },
  {
    value: 'total_fee',
    name: '总费',
    option: {
      align: 'center',
      width: '40px'
    }
  },
  {
    value: 'class_time',
    name: '上课日期',
    option: {
      width: '84px',
      align: 'left'
    }
  }
];
const classBaseInfCheck = [
  {
    value: 'class_code',
    name: '班级代码',
    option: {
      width: '76px'
    }
  },
  {
    value: 'name',
    name: '班级名称'
  },
  {
    value: 'org',
    name: '部门'
  },
  {
    value: 'specialized',
    name: '项目'
  },
  {
    value: 'fee',
    name: '级别',
    isHide: true
  },
  {
    value: 'scud',
    name: '课程表',
    option: {
      width: '44px',
      align: 'center'
    }
  },
  {
    value: 'is_rocking_number',
    headerSlot: {
      type: 'select',
      select: [
        {
          label: '是',
          value: true
        },
        {
          label: '否',
          value: false
        }
      ]
    },
    name: '摇号',
    option: {
      width: '60px',
      align: 'center'
    }
  },
  {
    value: 'is_publish',
    name: '对外发布',
    option: {
      width: '40px',
      align: 'center'
    }
  },
  {
    value: 'is_interview',
    name: '面试',
    headerSlot: {
      type: 'select',
      select: [
        {
          label: '是',
          value: true
        },
        {
          label: '否',
          value: false
        }
      ]
    },
    option: {
      width: '60px',
      align: 'center'
    }
  },
  {
    value: 'teacher',
    name: '教师',
    option: {
      align: 'center'
    }
  },
  {
    value: 'courses_count',
    name: '课次',
    option: {
      width: '30px',
      align: 'center'
    }
  },
  {
    value: 'class_fee',
    name: '学费',
    option: {
      align: 'center',
      width: '40px'
    }
  },
  {
    value: 'total_fee',
    name: '总费',
    option: {
      align: 'center',
      width: '40px'
    }
  },
  {
    value: 'class_time',
    name: '上课日期',
    option: {
      width: '84px',
      align: 'left'
    }
  }
];
const classInfTable = [
  {
    option: {
      type: 'selection',
      width: '25px'
    }
  },
  ...classBaseInfCheck,
  {
    value: 'class_time_sp',
    name: '课程安排',
    option: {
      'min-width': '120px'
    }
  },
  {
    value: 'reserved_count',
    name: 'Y',
    option: {
      width: '40px',
      align: 'center'
    }
  },
  {
    value: 'minister_sign_up_count',
    name: 'B',
    option: {
      width: '40px',
      align: 'center'
    }
  },
  {
    value: 'countStatus',
    name: '预约/实招/预招',
    option: {
      width: '88px',
      align: 'center'
    }
  },
  {
    value: 'class_status',
    name: '班级状态',
    headerSlot: {
      type: 'select',
      select: []
    },
    option: {
      width: '80px',
      align: 'center'
    }
  },
  {
    value: 'sign_up_status',
    name: '报名状态',
    headerSlot: {
      type: 'select',
      select: []
    },
    option: {
      width: '80px',
      align: 'center'
    }
  },
  {
    value: 'class_phase',
    name: '课程状态',
    headerSlot: {
      type: 'select',
      select: []
    },
    option: {
      width: '80px',
      align: 'center'
    }
  },
  {
    value: 'create_user_name',
    name: '创建者',
    isHide: true
  },
  {
    value: 'create_time',
    name: '创建时间',
    isHide: true
  },
  {
    value: 'action',
    name: '操作',
    option: {
      width: '76px',
      align: 'center'
    }
  }
];

const classInfTableRate = [
  {
    option: {
      type: 'selection'
    }
  },
  {
    value: 'class_code',
    name: '班级代码',
    option: {
      width: '76px'
    }
  },
  {
    value: 'name',
    name: '班级名称'
  },
  {
    value: 'org',
    name: '部门'
  },
  {
    value: 'specialized',
    name: '项目'
  },
  {
    value: 'fee',
    name: '级别'
  },
  {
    value: 'is_rocking_number',
    name: '摇号',
    isHide: true
  },
  {
    value: 'is_interview',
    name: '面试',
    isHide: true
  },
  {
    value: 'courses_count',
    name: '课次',
    isHide: true
  },
  {
    value: 'single_class_price',
    name: '单次课费'
  },
  {
    value: 'class_fee',
    name: '学费'
  },
  {
    value: 'total_fee',
    name: '总费用'
  },
  {
    value: 'teacher',
    name: '教师'
  },
  {
    value: 'remuneration',
    name: '课酬率'
  },
  {
    value: 'class_time',
    name: '上课时间',
    isHide: true
  },
  {
    value: 'scud',
    name: '课程表',
    isHide: true
  },
  {
    value: 'reserved_count',
    name: 'Y',
    isHide: true
  },
  {
    value: 'minister_sign_up_count',
    name: 'B',
    isHide: true,
    option: {
      align: 'center'
    }
  },
  {
    value: 'countStatus',
    name: '预约/实招/预招',
    isHide: true,
    option: {
      width: '100px',
      align: 'center'
    }
  },
  {
    value: 'class_status',
    name: '班级状态',
    isHide: true,
    headerSlot: {
      type: 'select',
      select: []
    }
  },
  {
    value: 'sign_up_status',
    name: '报名状态',
    headerSlot: {
      type: 'select',
      select: []
    },
    option: {
      width: '80px',
      align: 'center'
    }
  },
  {
    value: 'class_phase',
    name: '课程状态',
    headerSlot: {
      type: 'select',
      select: []
    },
    option: {
      width: '80px',
      align: 'center'
    }
  },
  {
    value: 'create_user_name',
    name: '创建者',
    isHide: true
  },
  {
    value: 'create_time',
    name: '创建时间',
    isHide: true
  },
  {
    value: 'action',
    name: '操作',
    option: {
      width: '76px'
    }
  }
];

const enrolmentTable = [
  {
    option: {
      type: 'selection'
    }
  },
  {
    option: {
      type: 'index'
    }
  },
  {
    value: 'reservation_number',
    name: '预约号'
  },
  {
    value: 'name',
    name: '学员姓名'
  },
  {
    value: 'id_card_no',
    name: '身份证号'
  },
  {
    value: 'age',
    name: '年龄'
  },
  {
    value: 'real_name',
    name: '监护人姓名',
    isHide: true
  },
  {
    value: 'phone',
    name: '监护人手机'
  },
  {
    value: 'relation',
    name: '监护人关系'
  },
  {
    value: 'insurance',
    name: '保险费'
  },
  {
    value: 'material_fee',
    name: '材料费'
  },
  {
    value: 'hosting_fee',
    name: '托管费'
  },
  {
    value: 'food_expenses',
    name: '伙食费'
  },
  {
    value: 'accompanying_fee',
    name: '陪读费'
  },
  {
    value: 'sign_up_fee',
    name: '总费用'
  },
  {
    value: 'actual_real_fee',
    name: '实际缴费'
  },
  {
    value: 'fee_group',
    name: '退费/补费'
  },
  {
    value: 'create_time',
    name: '报名时间'
  },
  {
    value: 'pay_time',
    name: '缴费时间'
  },
  {
    value: 'pay_end_time',
    name: '缴费截止'
  },
  {
    value: 'pay_type',
    name: '支付方式'
  },
  {
    value: 'sign_up_type',
    name: '报名方式'
  },
  {
    value: 'sign_up_status',
    name: '报名状态'
  },
  {
    value: 'keep_reserved',
    name: '保留名额'
  },
  {
    value: 'whether_transfer_class',
    name: '是否转班'
  },
  {
    value: 'use_reserved',
    name: '是否使用预留名额'
  },
  {
    value: 'sign_up_operator_name',
    name: '报名操作人'
  },
  {
    value: 'action',
    name: '操作',
    option: {
      width: '132px'
    }
  }
];

const classStatusTable = [
  {
    option: {
      type: 'selection'
    }
  },
  {
    option: {
      type: 'index'
    }
  },
  ...classBaseInf,
  {
    value: 'sign_up_status',
    name: '报名状态',
    headerSlot: {
      type: 'select',
      select: []
    },
    option: {
      width: '80px',
      align: 'center'
    }
  },
  {
    value: 'action',
    name: '操作',
    option: {
      width: '124px',
      align: 'center'
    }
  }
];

const classLottryTable = [
  {
    option: {
      type: 'selection'
    }
  },
  {
    option: {
      type: 'index'
    }
  },
  ...classBaseInf,
  {
    value: 'sign_up_status',
    name: '报名状态',
    headerSlot: {
      type: 'select',
      select: []
    },
    option: {
      width: '80px',
      align: 'center'
    }
  },
  {
    value: 'action',
    name: '操作',
    option: {
      width: '104px'
    }
  }
];

const classInterviewTable = [
  {
    option: {
      type: 'selection'
    }
  },
  {
    value: 'reservation_number',
    name: '预约号'
  },
  {
    value: 'name',
    name: '学员姓名'
  },
  {
    value: 'gender',
    name: '性别'
  },
  {
    value: 'id_card_no',
    name: '证件号码'
  },
  {
    value: 'phone',
    name: '家长手机'
  },
  {
    value: 'class_info_name',
    name: '班级'
  },
  {
    value: 'specialized',
    name: '项目'
  },
  {
    value: 'teacher',
    name: '教师'
  },
  {
    value: 'create_time',
    name: '报名时间'
  },
  {
    value: 'sign_up_type',
    name: '报名方式'
  },
  {
    value: 'interview_audit_status',
    name: '面试状态'
  },
  {
    value: 'interview_audit_status_operator_name',
    name: '操作人'
  },
  {
    value: 'interview_audit_status_operator_time',
    name: '操作时间'
  },
  {
    value: 'action',
    name: '操作',
    option: {
      align: 'center'
    }
  }

];

const classLottryResultTable = [
  {
    option: {
      type: 'selection'
    }
  },
  {
    value: 'rocking_number_order',
    name: '摇号顺序'
  },
  {
    value: 'reservation_number',
    name: '预约号'
  },
  {
    value: 'name',
    name: '学员姓名'
  },
  {
    value: 'id_card_no',
    name: '身份证号'
  },
  {
    value: 'age',
    name: '年龄'
  },
  {
    value: 'gender',
    name: '性别'
  },
  {
    value: 'real_name',
    name: '监护人'
  },
  {
    value: 'phone',
    name: '监护人手机'
  },
  {
    value: 'relation',
    name: '监护人关系'
  },
  {
    value: 'sign_up_fee',
    name: '总费用'
  },
  {
    value: 'rocking_number_status',
    name: '状态'
  },
  {
    value: 'sign_up_status',
    name: '缴费状态'
  }
];

const enterInterviewResultTable = [
  {
    option: {
      type: 'selection'
    }
  },
  {
    option: {
      type: 'index'
    }
  },
  {
    value: 'reservation_number',
    name: '预约号'
  },
  {
    value: 'name',
    name: '学员姓名'
  },
  {
    value: 'id_card_no',
    name: '身份证号'
  },
  {
    value: 'age',
    name: '年龄'
  },
  {
    value: 'gender',
    name: '性别'
  },
  {
    value: 'class_name',
    name: '班级'
  },
  {
    value: 'specialized_subject_full_name',
    name: '项目'
  },
  {
    value: 'teachers',
    name: '教师姓名'
  },
  {
    value: 'sign_up_type',
    name: '报名方式'
  },
  {
    value: 'action',
    name: '操作'
  }
];

const classPersonalTable = [
  {
    option: {
      type: 'index'
    }
  },
  {
    value: 'a',
    name: '班级名称'
  },
  {
    value: 'b',
    name: '班级代码'
  },
  {
    value: 'c',
    name: '所属部门'
  },
  {
    value: 'd',
    name: '所属分中心'
  },
  {
    value: 'e',
    name: '项目'
  },
  {
    value: 'f',
    name: '级别'
  },
  {
    value: 'h',
    name: '课表'
  },
  {
    value: 'remarks',
    name: '审核状态',
    headerSlot: {
      type: 'select',
      select: []
    }
  },
  {
    value: 'remarks2',
    name: '发布状态',
    headerSlot: {
      type: 'select',
      select: []
    }
  },
  {
    value: 'remarks3',
    name: '报名状态',
    headerSlot: {
      type: 'select',
      select: []
    }
  },
  {
    value: 'g',
    name: '课程阶段',
    headerSlot: {
      type: 'select',
      select: []
    }
  },
  {
    value: 'action',
    name: '操作',
    option: {
      width: '104px'
    }
  }
];

const personalTeachTable = [
  {
    option: {
      type: 'index'
    }
  },
  {
    value: 'org_full_name',
    name: '所属部门'
  },
  {
    value: 'specialized_subject_full_name',
    name: '项目名称'
  },
  {
    value: 'class_name',
    name: '班级名称'
  },
  {
    value: 'class_code',
    name: '班级代码',
    option: {
      width: '76px'
    },
    isHide: true
  },
  {
    value: 'original_teacher_name',
    name: '请假教师'
  },
  {
    value: 'supply_start_time',
    name: '请假开始'
  },
  {
    value: 'supply_end_time',
    name: '请假结束'
  },
  {
    value: 'new_teacher_name',
    name: '代课教师'
  },
  {
    value: 'supply_class_count',
    name: '课时数'
  },
  {
    value: 'audit_status',
    name: '审核状态',
    headerSlot: {
      type: 'select',
      select: []
    }
  },
  {
    value: 'action',
    name: '操作',
    option: {
      width: '164px'
    }
  }
];
const childClassTable = [
  {
    option: {
      type: 'selection'
    }
  },
  {
    option: {
      type: 'index'
    }
  },
  {
    value: 'name',
    name: '班级名称'
  },
  {
    value: 'class_code',
    name: '班级代码',
    option: {
      width: '76px'
    }
  },
  {
    value: 'class_size',
    name: '班级人数'
  },
  {
    value: 'org_full_name',
    name: '所属部门'
  },
  {
    value: 'specialized_subject_full_name',
    name: '所属项目'
  },
  {
    value: 'teacher',
    name: '老师'
  },
  {
    value: 'classroom',
    name: '教室'
  },
  {
    value: 'first_class_start_time',
    name: '开课日期'
  },
  {
    value: 'total_fee',
    name: '班级费用'
  }
];

const childClassDiyTable = [
  {
    option: {
      type: 'selection',
      selectable: row => row.split_status !== 1
    }
  },
  {
    name: '学员姓名',
    value: 'name'
  },
  {
    name: '身份证号',
    value: 'id_card_no'
  },
  {
    name: '性别',
    value: 'gender'
  },
  {
    name: '状态',
    value: 'split_status'
  }
];

const childClassSplitResultTable = [
  {
    option: {
      type: 'selection'
    }
  },
  {
    name: '学员姓名',
    value: 'name'
  },
  {
    name: '身份证号',
    value: 'id_card_no'
  },
  {
    name: '性别',
    value: 'gender'
  },
  {
    name: '年龄',
    value: 'age'
  },
  {
    name: '所属班级',
    value: 'class_name'
  },
  {
    name: '操作',
    value: 'action'
  }
];

const addressTable = [
  {
    name: '预约号',
    value: 'reservation_number'
  },
  {
    name: '班级名称',
    value: 'class_name'
  },
  {
    name: '部门',
    value: 'org_full_name'
  },
  {
    name: '项目',
    value: 'specialized_subject_name'
  },
  {
    name: '班级费用',
    value: 'total_fee'
  },
  {
    name: '学员姓名',
    value: 'contact_name'
  },
  {
    name: '证件号码',
    value: 'id_card_no'
  },
  {
    name: '邮寄地址',
    value: 'mail_address'
  },
  {
    name: '联系人',
    value: 'receive_contact'
  },
  {
    name: '联系电话',
    value: 'receive_contact_phone'
  },
  {
    name: '状态',
    value: 'mail_status'
  },
  {
    name: '操作',
    value: 'action'
  }
];

const guardTable = [
  {
    name: '班级名称',
    value: 'class_name'
  },
  {
    name: '部门',
    value: 'org_full_name'
  },
  {
    name: '项目',
    value: 'specialized_subject_name'
  },
  {
    name: '班级费用',
    value: 'total_fee'
  },
  {
    name: '姓名',
    value: 'name'
  },
  {
    name: '证件类型',
    value: 'id_card_type'
  },
  {
    name: '证件号码',
    value: 'id_card_no'
  },
  {
    name: '电话',
    value: 'phone'
  },
  {
    name: '身份类别',
    value: 'user_type'
  },
  {
    name: '修改时间',
    value: 'modify_time'
  }
];
const substituteTable = [
  {
    option: {
      type: 'selection'
    }
  },
  {
    name: '所属部门',
    value: 'org_name'
  },
  {
    name: '所属分中心',
    value: 'root_specialized_subject_name'
  },
  {
    name: '项目名称',
    value: 'specialized_subject_name'
  },
  {
    name: '班级名称',
    value: 'class_name'
  },
  {
    name: '上课时间',
    value: 'course_time',
    option: {
      width: '150px',
      align: 'left'
    }
  },
  {
    name: '请假日期',
    value: 'apply_time',
    option: {
      width: '84px',
      align: 'left'
    }
  },
  {
    name: '请假老师',
    value: 'apply_teacher_name',
    option: {
      align: 'center'
    }
  },
  {
    name: '请假原因',
    value: 'apply_reason'
  },
  {
    name: '代课教师',
    value: 'substitute_teacher_name',
    option: {
      align: 'center'
    }
  },
  {
    name: '课次',
    value: 'substitute_course_number',
    option: {
      align: 'center'
    }
  },
  {
    name: '创建时间',
    value: 'create_time'
  },
  {
    name: '创建人',
    value: 'operate_user_name',
    option: {
      align: 'center'
    }
  },
  {
    name: '操作',
    value: 'action'
  }
];
const replaceTable = [
  {
    option: {
      type: 'selection'
    }
  },
  {
    name: '所属部门',
    value: 'org_name'
  },
  // {
  //   name: '所属分中心',
  //   value: 'root_specialized_subject_name'
  // },
  // {
  //   name: '项目名称',
  //   value: 'specialized_subject_name'
  // },
  {
    name: '班级名称',
    value: 'class_name'
  },
  {
    name: '班级代码',
    value: 'class_code'
  },
  {
    name: '原老师',
    value: 'old_teacher_name',
    option: {
      align: 'center'
    }
  },
  {
    name: '新教师',
    value: 'new_teacher_name',
    option: {
      align: 'center'
    }
  },
  {
    name: '新老师上课日期起止日期',
    value: 'apply_time'
  },
  {
    name: '课次',
    value: 'replace_course_number',
    option: {
      align: 'center'
    }
  },
  // {
  //   name: '创建时间',
  //   value: 'replace_course_number'
  // },
  // {
  //   name: '创建人',
  //   value: 'replace_course_number',
  //   option: {
  //     align: 'center'
  //   }
  // },
  {
    name: '备注信息',
    value: 'remark'
  },
  {
    name: '创建人',
    value: 'operate_user_name'
  },
  {
    name: '创建时间',
    value: 'create_time'
  },
  {
    name: '操作',
    value: 'action'
  }
];
const classRefundTable = [
  {
    value: 'class_code',
    name: '班级代码',
    option: {
      width: '76px'
    }
  },
  {
    value: 'name',
    name: '班级名称'
  },
  {
    value: 'org',
    name: '部门'
  },
  {
    value: 'specialized',
    name: '项目'
  },
  {
    value: 'fee',
    name: '级别',
    isHide: true
  },
  {
    value: 'is_rocking_number',
    headerSlot: {
      type: 'select',
      select: [
        {
          label: '是',
          value: true
        },
        {
          label: '否',
          value: false
        }
      ]
    },
    name: '摇号',
    option: {
      width: '60px',
      align: 'center'
    }
  },
  {
    value: 'is_publish',
    name: '对外发布',
    option: {
      width: '40px',
      align: 'center'
    }
  },
  {
    value: 'is_interview',
    name: '面试',
    headerSlot: {
      type: 'select',
      select: [
        {
          label: '是',
          value: true
        },
        {
          label: '否',
          value: false
        }
      ]
    },
    option: {
      width: '60px',
      align: 'center'
    }
  },
  {
    value: 'teacher',
    name: '教师',
    option: {
      align: 'center'
    }
  },
  {
    value: 'courses_count',
    name: '课次',
    option: {
      width: '30px',
      align: 'center'
    }
  },
  {
    value: 'class_fee',
    name: '学费',
    option: {
      align: 'center',
      width: '40px'
    }
  },
  {
    value: 'total_fee',
    name: '总费',
    option: {
      align: 'center',
      width: '40px'
    }
  },
  {
    value: 'class_time',
    name: '上课日期',
    option: {
      width: '84px',
      align: 'left'
    }
  },
  {
    value: 'class_time_sp',
    name: '课程安排',
    option: {
      'min-width': '120px'
    }
  },
  {
    value: 'countStatus',
    name: '预约/实招/预招',
    option: {
      width: '88px',
      align: 'center'
    }
  },
  {
    value: 'class_status',
    name: '班级状态',
    headerSlot: {
      type: 'select',
      select: []
    },
    option: {
      width: '80px',
      align: 'center'
    }
  },
  {
    value: 'sign_up_status',
    name: '报名状态',
    headerSlot: {
      type: 'select',
      select: []
    },
    option: {
      width: '80px',
      align: 'center'
    }
  },
  {
    value: 'class_phase',
    name: '课程状态',
    headerSlot: {
      type: 'select',
      select: []
    },
    option: {
      width: '80px',
      align: 'center'
    }
  },
  {
    value: 'create_user_name',
    name: '创建者',
    isHide: true
  },
  {
    value: 'create_time',
    name: '创建时间',
    isHide: true
  },
  {
    value: 'action',
    name: '操作',
    option: {
      width: '76px',
      align: 'center'
    }
  }
];
const refundTable = [
  {
    option: {
      type: 'selection'
    }
  },
  {
    option: {
      type: 'index'
    }
  },
  {
    value: 'reservation_number',
    name: '预约号'
  },
  {
    value: 'name',
    name: '学员姓名'
  },
  {
    value: 'id_card_no',
    name: '身份证号'
  },
  {
    value: 'insurance',
    name: '保险费'
  },
  {
    value: 'material_fee',
    name: '材料费'
  },
  {
    value: 'hosting_fee',
    name: '托管费'
  },
  {
    value: 'food_expenses',
    name: '伙食费'
  },
  {
    value: 'accompanying_fee',
    name: '陪读费'
  },
  {
    value: 'sign_up_fee',
    name: '总费用'
  },
  {
    value: 'actual_real_fee',
    name: '实际缴费'
  },
  {
    value: 'can_batch_refund',
    name: '是否可批量退款'
  },
  {
    value: 'sign_up_status',
    name: '报名状态'
  }
];
const refundDetailTable = [
  {
    option: {
      type: 'index'
    }
  },
  {
    value: 'refund_number',
    name: '退款单号'
  },
  {
    value: 'reservation_number',
    name: '预约号'
  },
  {
    value: 'contact_name',
    name: '学员姓名'
  },
  {
    value: 'id_card_no',
    name: '证件号'
  },
  {
    value: 'refund_type_label',
    name: '退费类型'
  },
  {
    value: 'total_fee',
    name: '退费金额'
  },
  {
    value: 'courses',
    name: '退课课次'
  },
  {
    value: 'refund_source_label',
    name: '退费来源',
    option: {
      width: '220px'
    }
  },
  {
    value: 'refund_reason',
    name: '退费原因'
  },
  {
    value: 'create_time',
    name: '申请时间'
  },
  {
    value: 'operate_name',
    name: '操作员'
  },
  {
    value: 'refund_status',
    name: '状态',
    headerSlot: {
      type: 'select',
      select: []
    },
    option: {
      width: '100px'
    }
  }
];
const refundPettyTable = [
  {
    option: {
      type: 'index'
    }
  },
  {
    value: 'reservation_number',
    name: '预约号'
  },
  {
    value: 'name',
    name: '学员姓名'
  },
  {
    value: 'id_card_no',
    name: '证件号'
  },
  {
    value: 'class_fee',
    name: '学费退款'
  },
  {
    value: 'food_expenses',
    name: '伙食费'
  },
  {
    value: 'material_fee',
    name: '材料费'
  },
  {
    value: 'hosting_fee',
    name: '托管费'
  },
  {
    value: 'accompanying_fee',
    name: '陪读费'
  },
  {
    value: 'sign_up_fee',
    name: '总退款金额'
  }
];
const refundAllTable = [
  {
    option: {
      type: 'index'
    }
  },
  {
    value: 'reservation_number',
    name: '预约号'
  },
  {
    value: 'name',
    name: '学员姓名'
  },
  {
    value: 'id_card_no',
    name: '证件号'
  },
  {
    value: 'sign_up_fee',
    name: '总退款金额'
  }
];
export {
  guardTable,
  addressTable,
  childClassSplitResultTable,
  childClassDiyTable,
  childClassTable,
  classBaseInf,
  classInfTable,
  classStatusTable,
  enrolmentTable,
  classLottryTable,
  classInterviewTable,
  classLottryResultTable,
  classPersonalTable,
  personalTeachTable,
  enterInterviewResultTable,
  classInfTableRate,
  substituteTable,
  replaceTable,
  classRefundTable,
  refundTable,
  refundDetailTable,
  refundPettyTable,
  refundAllTable
};
